<template>
    <v-card flat class="conteneurKeywords" id="conteneurKeywords" style="width: 100%;">
        <v-card-title class="primary white--text"  style="height: 52px;  padding: 0px;">
          <v-btn icon @click="$emit('justCloseDialog')"><v-icon class="white--text">close</v-icon></v-btn>
          <div class="title tf_title_dialog" v-html="titleDialog"></div>
          <v-spacer></v-spacer>
          <v-btn v-if="$vuetify.breakpoint.smAndDown" flat @click="submitDialog()" class="white--text">{{ $t('submit') }}</v-btn>
        </v-card-title>
        <v-card-text>
          <div v-if="loading" class="text-xs-center ">
            <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
          </div>
          <div v-else>
            <v-alert
              v-if="updatedKeywords"
              :value="true"
              type="warning"
            >
              {{ $t('AIRepSeg') }}
            </v-alert>
            <v-alert
              v-else
              :value="true"
              type="success"
            >
              {{ $t('AIRepResSeg') }}
            </v-alert>

            <v-textarea
              box
              name="contentDialog"
              :label="this.$t('keywords')"
              auto-grow
              :value='contentDialog'
              v-model="contentDialog"
              @input="changeContentFile(contentDialog)"
            ></v-textarea>
          </div>
        </v-card-text>
        <v-card-actions v-if="!$vuetify.breakpoint.smAndDown && !closeDialogUniquement && !modifBaseCo">
          <v-spacer></v-spacer>
          <v-btn flat @click="closeDialog()">{{ $t('no') }}</v-btn>
          <v-btn 
            :loading="loadingModif"
            :disabled="!changeContent"
            color="primary"
            @click="submitDialog()"
          >{{ $t('save') }}</v-btn>
        </v-card-actions>
        <v-card-actions v-else-if="!$vuetify.breakpoint.smAndDown && !closeDialogUniquement && modifBaseCo">
          <v-spacer></v-spacer>
          <v-btn flat @click="$emit('justCloseDialog')">{{ $t('close') }}</v-btn>
          <v-btn color="primary" @click="$emit('closeDialog')">{{ $t('ok') }}</v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <v-btn flat @click="closeDialog()">{{ $t('close') }}</v-btn>
        </v-card-actions>
    </v-card>
</template>



<script>
export default {
  props: {
    dataDialog: {
      type: String,
      default: ''
    },
    licKey: {
      type: String
    },
    titleDialog: {
      type: String,
      default: 'Confirmation'
    },
    afficheDialog: {
      type: Boolean,
      default: false
    },
    closeDialogUniquement: {
      type: Boolean,
      default: false
    },
    modifBaseCo: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      contentDialog: '',
      keys: '',
      loadingModif: false,
      changeContent: false,
      contentRef: '',
      loading: false,
      updatedKeywords: false
    }
  },
  computed: {
    // url du bon serveur (prod / dev)
    serveurAI () {
      if (window.location.origin.indexOf('localhost') > -1) {
        return 'https://lb-sw-generator-dev-v2.watcheebox.net/'
      } else if (window.location.origin.indexOf('backoffice-preprod') > -1) {
        return 'https://lb-sw-generator-preprod-v2.watcheebox.net/'
      } else if (window.location.origin.indexOf('backoffice') > -1) {
        return 'https://lb-sw-generator.watcheebox.net/'
      } else {
        return 'https://lb-sw-generator.watcheebox.net/'
      }
    }
  },
  mounted () {},
  updated () {},
  methods: {
    // ferme la dialogBox
    closeDialog () {
      if (!this.closeDialogUniquement) {
        this.$emit('closeDialog')
      } else {
        this.$emit('justCloseDialog')
      }
      this.loadingModif = false
    },
    // check si le conteu change
    changeContentFile (content) {
      // console.log('le contenu changeContentFile', content)
      // console.log('le contenu changeContentFile this.contentRef', this.contentRef)
      if (content !== this.contentRef) {
        this.changeContent = true
      } else {
        this.changeContent = false
      }
    },
    // enregistre les modifications
    async submitDialog () {
      this.loadingModif = true
      // this.$emit('submitDialog', this.contentDialog)
      console.log('this.keywordUrl', this.contentDialog)
      let dataToPost = {}
      dataToPost.nameChunk = this.dataDialog.item.name
      dataToPost.content = this.contentDialog
      dataToPost.licKey = this.licKey
      const response = await this.axios.post(this.serveurAI + 'updateChunkFile',
      dataToPost,
        {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
      )
      // console.log(response.data)
      if (response.data.retour) {
        console.log('retour info : ', response.data.info)
        this.loadingModif = false
        this.$emit('majData', dataToPost)
        this.$emit('justCloseDialog')
      } else {
        console.log('info : ', response.data.info)
        this.loadingModif = false
      }
    },
    // ouvre le dialogue de modification les mots clés de la page
    async openDialogUpdateKeyword (data) {
      // console.log('this.faqDialog', this.faqDialog)
      // this.showDialogModifKeyword = true
      console.log('open keyword', data)
      this.changeContent = false
      if (data.item.content) {
        this.contentRef = data.item.content
        this.contentDialog = data.item.content
        this.loading = false
        // this.showDialogModifKeyword = true
      } else {
        console.log('info : ', 'pas de contenu')
        this.contentDialog = ['pas d\'url dispo']
        this.loading = false
      }
    }
  },
  watch: {
    // detect quand la dialogBow est effiché
    afficheDialog: function (val, oldVal) {
      console.log('afficheDialog val :', val)
      if (val) {
        this.loading = true
        this.openDialogUpdateKeyword(this.dataDialog)
      }
    }
  }
}
</script>

<style scoped>
  .tf_title_dialog {
    text-overflow: ellipsis;
    width: calc(100% - 180px);
    overflow: hidden;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzDialogModifContentFile.vue